import { TabFallback } from '@/components/TabFallback';
import { TeamCrumb } from '@/components/breadcrumbs/TeamCrumb';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from './types';

const Teams = lazy(() => import('@/pages/Teams').then((m) => ({ default: m.Teams })));
const TeamDetail = lazy(() =>
  import('@/pages/TeamDetail').then((m) => ({ default: m.TeamDetail })),
);

const listHandle: RouteHandle = {
  // Teams is a public surface, gated only on authentication; `plugins:view`
  // is the universal permission per Appendix A. The index child inherits this.
  crumb: 'Teams',
  requiredPermissions: ['plugins:view'],
};

const detailHandle: RouteHandle = {
  crumb: (params) => <TeamCrumb slug={params.slug} />,
  requiredPermissions: ['plugins:view'],
};

export const teamsRoutes: RouteObject[] = [
  {
    path: 'teams',
    handle: listHandle,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<TabFallback />}>
            <Teams />
          </Suspense>
        ),
      },
      {
        path: ':slug',
        handle: detailHandle,
        element: (
          <Suspense fallback={<TabFallback />}>
            <TeamDetail />
          </Suspense>
        ),
      },
    ],
  },
];
